import { render } from "./Hello.vue?vue&type=template&id=d9c63f28"
import script from "./Hello.vue?vue&type=script&lang=js"
export * from "./Hello.vue?vue&type=script&lang=js"

import "./Hello.vue?vue&type=style&index=0&id=d9c63f28&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__